export default __webpack_public_path__ + "static/media/image-douglas-hurley.7540fbb6.png";